import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type {
  ISettingsEmailsItemSavePayload,
  ISettingsEmailsSaveResponse,

} from '../types';
import {
  ADMIN_GENERAL_SETTINGS_EMAILS_PERMISSIONS,
  SETTINGS_EMAIL_SAVE_QUERY_KEY,
  SETTINGS_EMAIL_SAVE_URL,

} from '../constants';

export default function useSettingsRegistrationFieldsAddMutation(): ReturnType<
  typeof useContextMutation<ISettingsEmailsSaveResponse, Error, ISettingsEmailsItemSavePayload>
> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<
    ISettingsEmailsSaveResponse,
    Error,
    ISettingsEmailsItemSavePayload
  >({
    mutationKey: [SETTINGS_EMAIL_SAVE_QUERY_KEY],
    mutationFn: (payload) => fetchPost<ISettingsEmailsSaveResponse>(
      SETTINGS_EMAIL_SAVE_URL,
      payload,
      {
        permission: ADMIN_GENERAL_SETTINGS_EMAILS_PERMISSIONS.MAILERS_MANAGER_EDIT,
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [SETTINGS_EMAIL_SAVE_QUERY_KEY] });
      displayPresetToast('edited');
    },
  });
}
